import { CheckbookArrowLeftIcon } from './CheckbookArrowLeftIcon';

/**
 * author: Jeff Anders
 * id E1AF54E0-A2C9-41D4-89E0-62CD301F4B71
 * name checkbook-arrow-left
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/checkbook-arrow-left.svg
 * tags
 * - Banking 
 */
export const ChequebookArrowLeftIcon = CheckbookArrowLeftIcon;
export default ChequebookArrowLeftIcon